import { render, staticRenderFns } from "./section5.vue?vue&type=template&id=483eaa8f&scoped=true"
import script from "./section5.vue?vue&type=script&lang=js"
export * from "./section5.vue?vue&type=script&lang=js"
import style0 from "./section5.vue?vue&type=style&index=0&id=483eaa8f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483eaa8f",
  null
  
)

export default component.exports